import { Employee } from '../contexts/AppContext';

// 임시직 판별 기준 키워드
export const TEMPORARY_TEAM_KEYWORDS = [
  '미지정',
  '없음', 
  '임시',
  '지원',
  '도우미',
  '파트',
  '계약',
  '아르바이트',
  '외부',
  '프리랜서'
];

// 팀 소속 여부로 임시직 판별
export const isTemporaryByTeamStatus = (employee: Employee): boolean => {
  const team = employee.team?.trim().toLowerCase() || '';
  
  // 1. 팀이 없거나 비어있음
  if (!team || team === '') {
    return true;
  }
  
  // 2. 임시직 키워드 포함
  return TEMPORARY_TEAM_KEYWORDS.some(keyword => 
    keyword && team.includes(keyword.toLowerCase())
  );
};

// 직원 목록에서 임시직만 필터링
export const getTemporaryStaff = (employees: Employee[]): Employee[] => {
  return employees.filter(isTemporaryByTeamStatus);
};

// 직원 목록에서 정규직만 필터링
export const getRegularStaff = (employees: Employee[]): Employee[] => {
  return employees.filter(emp => !isTemporaryByTeamStatus(emp));
};

// 임시직 통계 정보
export const getTemporaryStaffStats = (employees: Employee[]) => {
  const temporaryStaff = getTemporaryStaff(employees);
  const regularStaff = getRegularStaff(employees);
  
  return {
    total: employees.length,
    temporary: temporaryStaff.length,
    regular: regularStaff.length,
    temporaryPercentage: employees.length > 0 ? 
      Math.round((temporaryStaff.length / employees.length) * 100) : 0,
    temporaryStaff,
    regularStaff
  };
};

// 임시직의 팀 배정 가능 여부 확인
export const canAssignToTeam = (employee: Employee, teamName: string): boolean => {
  // 임시직이면 어떤 팀에든 배정 가능
  if (isTemporaryByTeamStatus(employee)) {
    return true;
  }
  
  // 정규직이면 기존 팀만 가능
  return employee.team === teamName;
};

// 임시직을 특정 팀에 임시 배정
export const assignTemporaryToTeam = (employee: Employee, teamName: string): Employee => {
  if (!isTemporaryByTeamStatus(employee)) {
    console.warn(`직원 ${employee.name}은 임시직이 아니므로 팀 변경이 제한됩니다.`);
    return employee;
  }
  
  return {
    ...employee,
    team: teamName
  };
};

// 임시직 직원 정보 포맷팅
export const formatTemporaryStaffInfo = (employee: Employee): string => {
  const isTemp = isTemporaryByTeamStatus(employee);
  const status = isTemp ? '임시직' : '정규직';
  const team = employee.team || '미지정';
  
  return `${employee.name} (${status}, ${team}팀)`;
}; 